export const AGENT_ROUTE_SECTIONS = [
  {
    group: "ANA PANEL",
    items: [
      { value: "/live-simulation", label: "Canli Simulasyon" },
      { value: "/monitor", label: "Dashboard" },
      { value: "/chat", label: "AI Sohbet" },
      { value: "/call-center", label: "AI Cagri Merkezi" },
      { value: "/ai-email", label: "AI Email" },
      { value: "/boss-assistant", label: "AI Patron" },
      { value: "/google-ads", label: "AI Google Ads" },
      { value: "/ai-video", label: "AI Video" },
      { value: "/ai-bots", label: "AI Calisanlar" },
      { value: "/setup", label: "Kurulum Merkezi" },
      { value: "/social-media-connections", label: "Kanal Yonetimi" },
      { value: "/agents", label: "Temsilciler" },
      { value: "/plan", label: "Plan" },
    ],
  },
  {
    group: "AI CALISAN PANELLERI",
    items: [
      { value: "/employee-panels/manager", label: "AI Mudur" },
      { value: "/orders", label: "Siparis Sorumlusu" },
      { value: "/appointments", label: "Randevu Koordinatoru" },
      { value: "/quotes", label: "Teklif Uzmani" },
      { value: "/reservations", label: "Rezervasyon Sorumlusu" },
      { value: "/support-tickets", label: "Destek Uzmani" },
      { value: "/collections", label: "Tahsilat Sorumlusu" },
      { value: "/accounting", label: "Muhasebeci" },
      { value: "/social-media-manager", label: "Sosyal Medya Yonetici" },
      { value: "/data-analyst", label: "Veri Analisti" },
      { value: "/legal", label: "Avukat" },
      { value: "/tender-manager", label: "Ihale Yoneticisi" },
      { value: "/project-manager", label: "Proje Yoneticisi" },
      { value: "/sales-leads", label: "Satis Danismani" },
      { value: "/enrollments", label: "Egitim Danismani" },
      { value: "/memberships", label: "Uyelik Danismani" },
      { value: "/leave-requests", label: "IK Asistani" },
      { value: "/property-inquiries", label: "Emlak Danismani" },
      { value: "/construction", label: "Santiye Yoneticisi" },
      { value: "/salon", label: "Salon Studyosu" },
      { value: "/vet", label: "Klinik Defteri" },
      { value: "/dental", label: "Klinik Kayitlari" },
      { value: "/estetik", label: "Estetik Kayitlari" },
      { value: "/spor", label: "Studyo Yonetimi" },
      { value: "/kurs", label: "Ogrenci Takibi" },
      { value: "/otel", label: "Onburo" },
      { value: "/salon-yonetimi", label: "Salon Yonetimi (Cafe)" },
      { value: "/buro", label: "Buro Takibi (Hukuk)" },
      { value: "/mukellef", label: "Buro Yonetimi (Musavir)" },
      { value: "/satis-sureci", label: "Satis Sureci (Emlak)" },
      { value: "/eticaret", label: "E-Ticaret Operasyonu" },
      { value: "/servis-yonetimi", label: "Servis Yonetimi (Oto Servis)" },
      { value: "/eczane", label: "Eczane (Recete & Ilac)" },
      { value: "/optik", label: "Optik (Numara & Gozluk)" },
      { value: "/kres", label: "Kres (Sinif & Karne)" },
      { value: "/salon-takvimi", label: "Dugun Salonu (Takvim & Odeme)" },
      { value: "/cari", label: "Cari Hesap (Bakiye & Cek/Senet)" },
      { value: "/uretim", label: "Uretim & Teslim (Siparis Plani)" },
      { value: "/police", label: "Police & Yenileme (Sigorta)" },
      { value: "/program", label: "Seans Programi (Diyet/Egzersiz)" },
      { value: "/turlar", label: "Tur & Kontenjan (Turizm)" },
      { value: "/servis-kayitlari", label: "Servis Kayitlari (Teknik/Saha)" },
      { value: "/galeri", label: "Arac Portfoyu (Oto Galeri)" },
      { value: "/tahsilat-plani", label: "Duzenli Tahsilat (aidat/ucret/taksit)" },
      { value: "/onboarding-progress", label: "Karsilama Uzmani" },
      { value: "/employee-panels/patient", label: "Hasta Danismani" },
      { value: "/employee-panels/secretary", label: "Sekreter" },
      { value: "/employee-panels/receptionist", label: "Resepsiyonist" },
      { value: "/employee-panels/feedback", label: "Memnuniyet Uzmani" },
      { value: "/employee-panels/tracking", label: "Kargo Takip Uzmani" },
      { value: "/web-developer", label: "AI Web Developer" },
      { value: "/loyalty-qr", label: "QR Boomerang" },
      { value: "/spider", label: "Orumcek" },
    ],
  },
  {
    group: "PAZARLAMA",
    items: [
      { value: "/templates", label: "Sablonlar" },
      { value: "/campaigns", label: "Kampanyalar" },
      { value: "/email-marketing", label: "Email Marketing" },
      { value: "/sms-marketing", label: "SMS Marketing" },
    ],
  },
  {
    group: "OPERASYON ARACLARI",
    items: [
      { value: "/contacts", label: "Kisiler" },
      { value: "/loyalty", label: "Sadakat Programi" },
      { value: "/agent-analytics", label: "Agent Performans" },
      { value: "/payment-links", label: "Odeme Linkleri" },
    ],
  },
  {
    group: "AYARLAR",
    items: [
      { value: "/integrations", label: "Entegrasyonlar" },
      { value: "/zapier-settings", label: "Zapier / Make" },
      { value: "/gamification", label: "Basarilar" },
      { value: "/referral", label: "Referans Programi" },
      { value: "/web-widget", label: "Chat Widget" },
      { value: "/whatsapp-flows", label: "WA Formlar" },
      { value: "/notifications", label: "Bildirimler" },
      { value: "/audit-logs", label: "Denetim Gunlugu" },
    ],
  },
];

export const AGENT_ROUTE_VALUES = AGENT_ROUTE_SECTIONS.flatMap((section) =>
  section.items.map((item) => item.value)
);

export const AGENT_ROUTE_PRIORITY = ["/home", "/monitor", ...AGENT_ROUTE_VALUES.filter((r) => r !== "/monitor")];

export const AGENT_ROUTE_ALIASES = {
  "/ai-bots": ["/ai-bots-legacy", "/ai-personas"],
  "/appointments": ["/appointments/list", "/appointments/calendar", "/appointments/settings"],
  "/call-center": ["/call-center-setup"],
  "/integrations": ["/ecommerce-integration", "/crm-integration"],
  "/orders": ["/orders/list", "/orders/catalog", "/orders/settings", "/orders/analytics"],
  "/quotes": ["/quotes/requests", "/quotes/templates", "/quotes/settings"],
  "/setup": ["/chatbot-setup", "/call-center-setup"],
};
